import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import HotelCategory from "../types/HotelCategory";

type Output = HotelCategory[];

export default function useHotelCategoriesGetAll (
    hotelId?: number,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    return useCacheQuery<Output>(
        ["hotel-categories-by-hotel", hotelId],
        () => {
            return client.get<any>(`categories`, {
                "hotel": hotelId,
                "itemsPerPage": 100
            });
        },
        options
    );
}